import { render } from "./TrucksTable.vue?vue&type=template&id=d721fe90&scoped=true&lang=pug"
import script from "./TrucksTable.vue?vue&type=script&lang=ts"
export * from "./TrucksTable.vue?vue&type=script&lang=ts"

import "./TrucksTable.vue?vue&type=style&index=0&id=d721fe90&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d721fe90"

export default script